import React, { useContext } from 'react';
import { withTheme } from 'styled-components';

import { Context } from '@store/store';

import { StyledBetaButton } from './beta-button.styles';

const BetaButton = ({ theme }) => {
  const [{ efedNoAuth }, dispatch] = useContext(Context);
  return efedNoAuth ? null : (
    <StyledBetaButton
      onClick={() => dispatch({ type: 'TOGGLE_BETA_MODAL', payload: true })}
      title="Посмотреть информацию о бета-тестировании"
    >
      <svg
        width="16"
        height="25"
        viewBox="0 0 16 25"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M2 6.00596C2.48392 4.6703 3.43908 3.54401 4.6963 2.8266C5.95353 2.10919 7.43169 1.84694 8.86897 2.08631C10.3063 2.32568 11.6099 3.05122 12.549 4.13442C13.4882 5.21761 14.0022 6.58857 14 8.00447C14 12.0015 7.82504 14 7.82504 14"
          fill={theme.themeColors.beta.button.background}
        />
        <path
          d="M2 6.00596C2.48392 4.6703 3.43908 3.54401 4.6963 2.8266C5.95353 2.10919 7.43169 1.84694 8.86897 2.08631C10.3063 2.32568 11.6099 3.05122 12.549 4.13442C13.4882 5.21761 14.0022 6.58857 14 8.00447C14 12.0015 7.82504 14 7.82504 14"
          stroke={theme.themeColors.beta.button.iconColor}
          strokeWidth="3"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M8 22.5H8.025H8Z"
          fill={theme.themeColors.beta.button.background}
        />
        <path
          d="M8 22.5H8.025"
          stroke={theme.themeColors.beta.button.iconColor}
          strokeWidth="4"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </StyledBetaButton>
  );
};

export default withTheme(BetaButton);
